/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Try_Magic_Error_Too_LongInputs */

const en_try_magic_error_too_long = /** @type {(inputs: Try_Magic_Error_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Text is too long. Maximum length is ${i?.max} characters.`)
};

const es_try_magic_error_too_long = /** @type {(inputs: Try_Magic_Error_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El texto es demasiado largo. La longitud máxima es ${i?.max} caracteres.`)
};

/**
* | output |
* | --- |
* | "Text is too long. Maximum length is {max} characters." |
*
* @param {Try_Magic_Error_Too_LongInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_error_too_long = /** @type {((inputs: Try_Magic_Error_Too_LongInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Error_Too_LongInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_error_too_long(inputs)
	return en_try_magic_error_too_long(inputs)
});